import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import RegisterSelector from './Selector'
import ApplicantSignUp from './ApplicantSignUp'
import EventOrgSignUp from './EventOrgSignUp'

const useQuery = () => {
  const { search } = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}

const RegisterAccountPage = () => {
  const accountType = useQuery().get('accountType')
  if (accountType === 'applicant') {
    return <ApplicantSignUp />
  } else if (accountType === 'event') {
    return <EventOrgSignUp />
  } else if (accountType === 'learner') {
    return 'Learning account registration'
  } else {
    return <RegisterSelector />
  }
}

export default RegisterAccountPage
